export default function FormatNumber(num: number) {
  if (num < 1000) return String(num);
  if (num < 10000) return String(Math.floor(num / 1000)) + 'k';
  if (num < 100000) return String(Math.floor(num / 10000) * 10) + 'k';
  if (num < 1000000) return String(Math.floor(num / 100000) * 100) + 'k';
  if (num < 10000000) return String(Math.floor(num / 1000000)) + 'M';
  return String(Math.floor(num / 10000000) * 10) + 'M';
}
